import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'

@Component({
  selector: 'app-training-page',
  standalone: true,
  imports: [],
  template: '',
})
export class TrainingPageComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {
    window.location.href = '/api/training/guide'
    this.router.navigate(['/app/meetings/past'])
  }
}
